import { createRoute, useLoaderData } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import { unwrapPageInitialData, type PageInitialData } from "~/app/api/pageData";
import { checkoutSummaryPageQueryOptions } from "~/app/api/pageData/checkoutSummaryPageQuery";
import type { CheckoutSummaryPageInitialData } from "~/app/api/pageData/checkoutSummaryPageInitialData";
import { StorefrontShellFrame } from "~/app/shell/StorefrontShellFrame";
import { useStorefrontShellProps } from "~/app/router/storefrontShellPropsContext";
import { rootRoute } from "~/app/router/rootRoute";
import { createCheckoutPage } from "~/pages/CheckoutPage/CheckoutPage";
import CheckoutHeader from "~/features/Checkout/components/CheckoutHeader";
import { resolveActiveCartResourceId } from "~/domains/cart/utils/cartResourceIdentity";

function CheckoutSummaryRoute() {
  const result = useLoaderData({
    from: "/checkout/multi/summary/view",
  }) as PageInitialData<CheckoutSummaryPageInitialData>;
  const shellProps = useStorefrontShellProps();

  return (
    <StorefrontShellFrame variant={shellProps.variant} metadata={result.metadata} header={<CheckoutHeader />}>
      {createCheckoutPage(result.data?.countries ?? [])}
    </StorefrontShellFrame>
  );
}

export async function loadCheckoutSummaryPageData(context: { queryClient: QueryClient }) {
  const activeCartId = await resolveActiveCartResourceId();
  const result = await context.queryClient.ensureQueryData(checkoutSummaryPageQueryOptions(activeCartId));

  return unwrapPageInitialData(result);
}

export const checkoutSummaryRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/checkout/multi/summary/view",
  loader: async ({ context }) => loadCheckoutSummaryPageData(context),
  component: CheckoutSummaryRoute,
});
